exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll-comments {\n\tposition: relative;\n\theight: 500px;\n}\n", ""]);

// exports
